<smrts-page tabTitle="Template do laudo">

  <div header class="header-container">

    <h1 class="primary-color page-title">Template do laudo</h1>

    <button mat-icon-button matTooltip="Voltar" class="accent-color" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <button mat-flat-button class="white-text-button btn-salvar" (click)="salvar()" [disabled]="salvando">
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>

  </div>

  <div class="content">

    <mat-card class="main-card">

      <p-tabs value="0" class="tabs-template">
        <p-tablist>
          <p-tab value="0">
            Campos do relatório
            <i class="pi pi-info-circle info-icon accent-color"
              pTooltip="Campos que preenchem o relatório de acordo com o template abaixo (ex: endereço, área útil, nº de quartos, nomes das pessoas). A Tag permite referenciar um campo isoladamente no HTML (campos.<tag>)."></i>
          </p-tab>
          <p-tab value="1">HTML</p-tab>
          <p-tab value="2">Visualização</p-tab>
        </p-tablist>

        <p-tabpanels class="tabpanels">
          <p-tabpanel class="tabpanel" value="0">
            <app-campos-modelo-vistoria [campos]="modelo.campos" (camposChange)="modelo.campos = $event"></app-campos-modelo-vistoria>
          </p-tabpanel>

          <p-tabpanel class="tabpanel" value="1">
            <app-html-template-editor [(html)]="html"></app-html-template-editor>
          </p-tabpanel>

          <p-tabpanel class="tabpanel" value="2">
            <app-visualizacao-template-html [modeloId]="id" [html]="html"></app-visualizacao-template-html>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>

    </mat-card>

  </div>

</smrts-page>
